import React from 'react'
import Select, { components } from 'react-select'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import moment from '../../../../lib/moment.js'
import { Button } from 'reactstrap'
import { FONTS } from '../../../../constants'

export const customStyles = {
  menuList: (base) => ({
    ...base,
    maxHeight: 400,
    overflowY: 'auto',
  }),
  control: (base, state) => ({
    ...base,
    height: 30,
    background: !state.isDisabled ? "#FFFFFF" : '#e9ecef',
    minHeight: 30,
    maxWidth: 200,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    height: 20,
    minHeight: 20,
    padding: 0,
  }),
  option: (base, state) => ({
    ...base,
    height: 30,
    minHeight: 30,
    maxWidth: 200,
    backgroundColor: state.isFocused ? '#DEEBFF' : 'white',
    color: state.isDisabled ? '#CCCCCC' : 'black',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "80%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
  }),
}

const MultiValueContainer = ({ selectProps, data }) => {
  const label = data.label
  const allSelected = selectProps.value
  const index = allSelected.findIndex(selected => selected.label === label)
  const isLastSelected = index === allSelected.length - 1
  const labelSuffix = isLastSelected ? `` : ", "
  const val = `${label}${labelSuffix}`
  return val
}

const Option = (props) => {
  const submittedLOB = get(props, 'selectProps.submittedLOB', [])
  return (
    <components.Option { ...props }>
      <Row>
        <input
          style={ { marginRight: 5 } }
          type='checkbox'
          checked={ get(props, 'isSelected') }
        />
        <Circle color={ !submittedLOB.includes(get(props, 'value')) ? '#CCCCCC' : '#5CB85C' } />
        { `${get(props, 'label')}` }
      </Row>
    </components.Option>
  )
}

export const OverallButton = class extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if ((JSON.stringify(get(nextProps, 'efficiencyResources')) !== JSON.stringify(prevState.efficiencyResources)
    && JSON.stringify(get(nextProps, 'lobs')) !== JSON.stringify(prevState.lobs))
    || JSON.stringify(get(nextProps, 'selectedIDs')) !== JSON.stringify(prevState.selectedIDs)) {
      let submittedLOB = []
      submittedLOB = get(nextProps, 'efficiencyResources', []).map(res => {
        if (get(res, 'is_submited')) return get(res, 'lob_id')
        return null
      })
      let lobs = []
      lobs = get(nextProps, 'lobs', []).map(lob => {
        return {
          label: get(lob, 'name', ''),
          value: get(lob, '_id'),
        }
      })
      set(tempState, 'selectedIDs', get(nextProps, 'selectedIDs'))
      set(tempState, 'efficiencyResources', get(nextProps, 'efficiencyResources'))
      set(tempState, 'submittedLOB', submittedLOB)
      set(tempState, 'lobs', lobs)
    }
    return tempState
  }

  state={
    lobs: [],
    submitted: [],
    selectedIDs: [],
    submittedLOB: [],
  }

  handleCheckBox = (e) => {
    const handleSelectLOB = get(this.props, 'handleSelectLOB')
    handleSelectLOB(e)
  }

  render() {
    const period = moment(get(this.props, 'period'))
    const handlePeriod = get(this.props, 'handlePeriod')
    return (
      <Buttons>
        <ArrowButton
          background='white'
          onClick={ () => {
            handlePeriod(moment(period).subtract(1, 'month'))
          } }
        >&#65308;</ArrowButton>
        <LabelMonth>{ period.format('MMMM YYYY') }</LabelMonth>
        <ArrowButton
          background='white'
          onClick={ () => {
            handlePeriod(moment(period).add(1, 'month'))
          } }
        >&#65310;</ArrowButton>
        <SelectInputField
          styles={ customStyles }
          closeMenuOnSelect={ false }
          isMulti
          isSearchable={ false }
          isClearable={ false }
          value={ (() => {
            let submitted
            if (get(this.props, 'lob_ids') === '' && get(this.props, 'setDefault')) {
              submitted = this.state.lobs.filter(lob => this.state.submittedLOB.includes(get(lob, 'value')))
            } else {
              submitted = this.state.lobs.filter(lob => {
                const found = find(this.state.selectedIDs, {
                  value: get(lob, 'value'),
                })
                return found || null
              })
            }
            return submitted
          })() }
          components={ { Option, MultiValueContainer } }
          options={ orderBy(this.state.lobs, 'label', 'asc') }
          hideSelectedOptions={ false }
          backspaceRemovesValue={ false }
          onChange={ (e) => this.handleCheckBox(e) }
          // isOptionDisabled={ (option) => option.disabled }
          submittedLOB={ this.state.submittedLOB }
          selectedIDs={ this.state.selectedIDs }
          placeholder='Select LOB'
        />
      </Buttons>
    )
  }
}

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  width: 40%;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const ArrowButton = styled(Button)`
  height: 30px;
  width: 40px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: black;
  font-size: 12px;
  border: 1px solid #E6E6E6;
`
const LabelMonth = styled.label`
  width: 100px;
  margin-top: 2%;
  text-align: center;
`
const SelectInputField = styled(Select)`
  width : 220px;
  margin-right: 10px;
  font-family: ${FONTS.GOTHAM};
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${props => { return props.color }};
  border-radius: 50%;
  margin-right: 8px;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab/button-group/overall.js